import User from '../User'

export default class GetUserMutationPayload {
  user: User | null

  constructor (user: User | null) {
    this.user = user
  }
}
